export default {
  select: 'Välj bredbandsabonnemang',
  generalErrorMessage:
    'Något gick fel när informationen skulle hämtas, var god försök senare',
  personalIdentityNumber: {
    confirm: 'Bekräfta ditt personnummer',
    format: 'ÅÅÅÅDDMM-XXXX',
    incorrect: 'Felaktigt personnummerformat',
  },
  downloadSpeed: 'Nedladdningshastighet',
  uploadSpeed: 'Uppladdningshastighet',
  price: 'Pris',
  monthlyPrice: 'Månadspris',
  bindingPeriod: 'Bindningstid',
  months: 'månader',
  krPerMonth: 'kr/mån',
  confirmationPage: {
    tnxForOrder: 'Tack för din beställning',
    confirmationViaEmail: 'Du kommer få en beställningsbekräftelse via mail',
    supportContacts: 'Kontaktuppgifter kundservice',
    phone: 'Telefon',
    email: 'Email',
  },
  rotRutOffer: {
    offerTotalPrice: 'Nytt kampanjpris',
    updateYourOrder: 'Uppdatera din beställning av fiberanslutning',
    information: 'Information',
    needToSelectService:
      'Du behöver välja bredbandsabonnemang för att ta del av denna kampanj.',
  },
  yourCurrentPrice: 'Ditt nuvarande pris',
  yourCurrentPriceWithBundleDiscount:
    'Ditt nuvarande pris med bredbandsabonnemang',
  addRot: 'Lägg till ROT-avdrag',
  addRotWithBundleDiscount: 'Lägg till Rot-avdrag och bredbandsabonnemang',
  addRut: 'Lägg till RUT-avdrag',
  addRutWithBundleDiscount: 'Lägg till Rut-avdrag och bredbandsabonnemang',
  addRotAndRut: 'Lägg till Rot-avdrag och Rut-avdrag',
  addRotAndRutWithBundleDiscount:
    'Lägg till Rot-avdrag, Rut-avdrag och bredbandsabonnemang',
  iWant: 'Jag vill ha',
  conversion: {
    offerPageTitle: 'Uppdatera din beställning av fiberanslutning',
    fiberBundleChkBoxLabel:
      'i rabatt på min fiberanslutning tillsammans med bredbandsabonnemang',
    next: 'Fortsätt',
    errorCurrentOfferSubmitted:
      'Välj ett annat alternativ än ditt nuvarande erbjudande',
    showServicesBtnText: 'Visa bredbandsabonnemang',
  },
  serviceSelector: {
    pageTitle: 'Välj bredbandsabonnemang',
    viewMoreDetails: 'Se detaljer och välj',
  },
  summary: {
    mainAccessPrice: 'Installationskostnad',
    confirmOrder: 'Bekräfta din beställning',
    discountedMainAccessPrice: 'Uppdaterat pris',
    earlierPrice: 'Tidigare pris',
    priceDisclaimer: 'Eventuella extra anslutningar är exkluderade i priset',
    legalCheckBox:
      'Jag godkänner härmed det nya kampanjpriset för min fiberanslutning samt åtar mig att teckna vald tjänst enligt ovan. Jag är medveten om att alla övriga villkor för min fiberbeställning gäller oförändrat.',
    errorPlacingOrder:
      'Uppdateringen kunde inte genomföras, var god försök lite senare',
    acceptAboveInfo: 'Du måste godkänna ovanstående information',
    order: 'Beställ',
  },

  DISCOUNT: 'Rabatt',

  FIBER_BUNDLE: 'Rabatt för bredbandsabonnemang',

  ROT: 'Rot-avdrag',

  RUT: 'Rut-avdrag',
};
